<template>
  <div id="details-page">
    <div class="mobile-toolbar mobile-only">
      <div class="search-overview">
        <b
          >{{ searchParameters.itineraries[0].origin.value.code }} -
          {{
            searchParameters.itineraries[
              searchParameters.itineraries.length - 1
            ].destination.value.code
          }}</b
        >
        <br />
        {{ selectedFlights.outbound.formattedDepartureDate }}
      </div>
      <b-button size="is-small" @click="toggleMobileReview()" icon-right="tune"
        >Flight review</b-button
      >
    </div>

    <b-modal
      class="mobile-review-modal"
      :active.sync="mobileReviewModal"
      :can-cancel="[true, true, true]"
      full-screen
    >
      <trip-review
        id="trip-review"
        :errors="errors"
        :validationError="validationError"
      >
        <b-button
          class="width-100"
          icon-left="close"
          type="is-primary"
          @click="toggleMobileReview()"
          >Close review</b-button
        >
        <b-message type="is-danger" v-if="errors.length || validationError">
          <b>Please correct the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
          <ul
            v-for="(error, index) in paymentValidationErrors"
            :key="'error-' + index"
          >
            <li>
              {{
                error
                  .split(/(?=[A-Z])/)
                  .join(" ")
                  .toLowerCase()
                  .replace("valid", "invalid")
              }}
            </li>
          </ul>
        </b-message>
      </trip-review>
    </b-modal>

    <trip-review
      id="trip-review"
      class="desktop-only"
      :errors="errors"
      :validationError="validationError"
    >
      <b-message type="is-danger" v-if="errors.length || validationError">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
        <ul
          v-for="(error, index) in paymentValidationErrors"
          :key="'error-' + index"
        >
          <li>
            {{
              error
                .split(/(?=[A-Z])/)
                .join(" ")
                .toLowerCase()
                .replace("valid", "invalid")
            }}
          </li>
        </ul>
      </b-message>
    </trip-review>

    <div class="main-content">
      <div class="steps">
        <div class="block-heading">{{ blockHeading }}</div>
        <div class="width-100 desktop-only">
          <b-steps
            type="is-primary"
            v-model="stepBlock"
            :has-navigation="false"
          >
            <b-step-item icon="account"></b-step-item>
            <b-step-item icon="account-plus"></b-step-item>
            <b-step-item icon="format-list-checkbox"></b-step-item>
            <b-step-item icon="credit-card"></b-step-item>
            <b-step-item icon="check"></b-step-item>
          </b-steps>
        </div>
      </div>

      <transition name="rotate-in">
        <form class="block-1" v-if="block == 1">
          <div class="passenger-list">
            <div
              class="container-div"
              v-for="(passenger, index) in adults"
              :key="'adult-' + index"
            >
              <div class="passenger-block" :class="{ first: index === 0 }">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Adult)
                </h3>
                <h3 class="passenger-type" v-else>
                  Adult passenger {{ index + 1 }}
                </h3>
                <!-- v-if="adultSettings.showTitle" -->
                <b-field
                  label="Title"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.title }"
                  :message="{ 'Title required': passenger.errors.title }"
                >
                  <b-select v-model="passenger.title" expanded required>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Ms">Ms</option>
                  </b-select>
                </b-field>
                <b-field
                  label="First Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.firstName }"
                  :message="{
                    'First name required': passenger.errors.firstName
                  }"
                >
                  <b-input
                    @input="val => handleNameInput(val, passenger)"
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    required
                  ></b-input>
                </b-field>
                <!-- <b-field
                  v-if="adultSettings.middleNameRequired"
                  label="Middle Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.middleName }"
                  :message="{
                    'Middle name required': passenger.errors.middleName
                  }"
                >
                  <b-input
                    @input="passenger.errors.middleName = false"
                    v-model="passenger.middleName"
                    required
                  ></b-input>
                </b-field> -->
                <b-field
                  label="Last Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.lastName }"
                  :message="{ 'Last name required': passenger.errors.lastName }"
                >
                  <b-input
                    @input="passenger.errors.lastName = false"
                    v-model="passenger.lastName"
                    required
                  ></b-input>
                </b-field>
                <b-field
                  label="Date of Birth"
                  :label-position="labelPosition"
                  :type="{ 'is-danger': passenger.errors.dateOfBirth }"
                  :message="{
                    'Date of birth required': passenger.errors.dateOfBirth
                  }"
                >
                  <b-datepicker
                    placeholder="Click to select..."
                    position="is-top-right"
                    v-model="passenger.dateOfBirth"
                    :years-range="[-100, 100]"
                    :focused-date="focusedDate"
                    :max-date="childMin"
                    required
                    @input="passenger.errors.dateOfBirth = false"
                  ></b-datepicker>
                </b-field>
                <!-- v-if="adultSettings.showNationality" -->
                <b-field
                  v-if="isInternational"
                  label="Nationality"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.nationality }"
                  :message="{
                    'Nationality required': passenger.errors.nationality
                  }"
                >
                  <b-select v-model="passenger.nationality" expanded required>
                    <option
                      v-for="country in countries"
                      :key="country.code"
                      :value="country.code"
                      >{{ country.name }}</option
                    >
                  </b-select>
                </b-field>
                <!-- v-if="adultSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport number"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.passportNumber }"
                  :message="{
                    'Passport number required': passenger.errors.passportNumber
                  }"
                >
                  <b-input
                    @input="passenger.errors.passportNumber = false"
                    v-model="passenger.passportNumber"
                    required
                  ></b-input>
                </b-field>
                <!-- v-if="adultSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport country"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.passportCountry }"
                  :message="{
                    'Passport country required':
                      passenger.errors.passportCountry
                  }"
                >
                  <b-select
                    v-model="passenger.passportCountry"
                    expanded
                    required
                  >
                    <option
                      v-for="country in countries"
                      :key="country.code"
                      :value="country.code"
                      >{{ country.name }}</option
                    >
                  </b-select>
                </b-field>
                <!-- v-if="adultSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport expiry"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.tempPassportExpiry }"
                  :message="{
                    'Passport expiry required':
                      passenger.errors.tempPassportExpiry
                  }"
                >
                  <b-datepicker
                    placeholder="Click to select..."
                    position="is-top-right"
                    v-model="passenger.tempPassportExpiry"
                    :years-range="[0, 10]"
                    :min-date="new Date()"
                    :max-date="null"
                    @input="passenger.errors.tempPassportExpiry = false"
                    required
                  ></b-datepicker>
                </b-field>
                <!-- <b-field
                  v-if="
                    adultSettings.showIdNumber ||
                      adultSettings.requireAPIS ||
                      adultSettings.requireSFPD
                  "
                  :label="'I.D. number'"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.documentNumber }"
                  :message="{
                    'Document number required': passenger.errors.documentNumber
                  }"
                >
                  <b-input
                    @input="passenger.errors.documentNumber = false"
                    v-model="passenger.documentNumber"
                    required
                  ></b-input>
                </b-field> -->
                <div
                  class="baggage-section"
                  v-if="priceResponse.baggageOptions.allBaggage.length > 0"
                >
                  <div
                    class="bag-input"
                    v-for="(bag, index) in priceResponse.baggageOptions
                      .allBaggage"
                    :key="'adultbag-' + index"
                  >
                    <b-checkbox
                      :true-value="true"
                      :false-value="false"
                      v-model="
                        passenger.baggageSelection.find(e => e.id == bag.id)
                          .selected
                      "
                    >
                      <b>
                        Add {{ bag.direction.toLowerCase() }} baggage:
                        {{ bag.description }}
                      </b>
                    </b-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="container-div"
              v-for="(passenger, index) in children"
              :key="'child-' + index"
            >
              <div class="passenger-block">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Child)
                </h3>
                <h3 class="passenger-type" v-else>
                  Child passenger {{ index + 1 }}
                </h3>
                <!-- v-if="childSettings.showTitle" -->
                <b-field
                  label="Title"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.title }"
                  :message="{ 'Title required': passenger.errors.title }"
                >
                  <b-select v-model="passenger.title" expanded required>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Ms">Ms</option>
                  </b-select>
                </b-field>
                <b-field
                  label="First Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.firstName }"
                  :message="{
                    'First name required': passenger.errors.firstName
                  }"
                >
                  <b-input
                    @input="val => handleNameInput(val, passenger)"
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    required
                  ></b-input>
                </b-field>
                <!-- <b-field
                  v-if="childSettings.middleNameRequired"
                  label="Middle Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.middleName }"
                  :message="{
                    'Middle name required': passenger.errors.middleName
                  }"
                >
                  <b-input
                    @input="passenger.errors.middleName = false"
                    v-model="passenger.middleName"
                    required
                  ></b-input>
                </b-field> -->
                <b-field
                  label="Last Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.lastName }"
                  :message="{ 'Last name required': passenger.errors.lastName }"
                >
                  <b-input
                    @input="passenger.errors.lastName = false"
                    v-model="passenger.lastName"
                    required
                  ></b-input>
                </b-field>
                <b-field
                  label="Date of Birth"
                  :label-position="labelPosition"
                  :type="{ 'is-danger': passenger.errors.dateOfBirth }"
                  :message="{
                    'Date of birth required': passenger.errors.dateOfBirth
                  }"
                >
                  <b-datepicker
                    placeholder="Click to select..."
                    v-model="passenger.dateOfBirth"
                    position="is-top-right"
                    :years-range="[-12, 12]"
                    :min-date="childMin"
                    :max-date="travelDate"
                    @input="passenger.errors.dateOfBirth = false"
                    required
                  ></b-datepicker>
                </b-field>
                <!-- v-if="childSettings.showNationality" -->
                <b-field
                  v-if="isInternational"
                  label="Nationality"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.nationality }"
                  :message="{
                    'Nationality required': passenger.errors.nationality
                  }"
                >
                  <b-select v-model="passenger.nationality" expanded required>
                    <option
                      v-for="country in countries"
                      :key="country.code"
                      :value="country.code"
                      >{{ country.name }}</option
                    >
                  </b-select>
                </b-field>
                <!-- v-if="childSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport number"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.passportNumber }"
                  :message="{
                    'Passport number required': passenger.errors.passportNumber
                  }"
                >
                  <b-input
                    @input="passenger.errors.passportNumber = false"
                    v-model="passenger.passportNumber"
                    required
                  ></b-input>
                </b-field>
                <!-- v-if="childSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport country"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.passportCountry }"
                  :message="{
                    'Passport country required':
                      passenger.errors.passportCountry
                  }"
                >
                  <b-select
                    v-model="passenger.passportCountry"
                    expanded
                    required
                  >
                    <option
                      v-for="country in countries"
                      :key="country.code"
                      :value="country.code"
                      >{{ country.name }}</option
                    >
                  </b-select>
                </b-field>
                <!-- v-if="childSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport expiry"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.tempPassportExpiry }"
                  :message="{
                    'Passport expiry required':
                      passenger.errors.tempPassportExpiry
                  }"
                >
                  <b-datepicker
                    placeholder="Click to select..."
                    v-model="passenger.tempPassportExpiry"
                    position="is-top-right"
                    :max-date="null"
                    @input="passenger.errors.tempPassportExpiry = false"
                    required
                  ></b-datepicker>
                </b-field>
                <!-- <b-field
                  v-if="
                    childSettings.showIdNumber ||
                      childSettings.requireAPIS ||
                      childSettings.requireSFPD
                  "
                  :label="'I.D. number'"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.documentNumber }"
                  :message="{
                    'Document number required': passenger.errors.documentNumber
                  }"
                >
                  <b-input
                    @input="passenger.errors.documentNumber = false"
                    v-model="passenger.documentNumber"
                    required
                  ></b-input>
                </b-field> -->
                <div
                  class="baggage-section"
                  v-if="priceResponse.baggageOptions.allBaggage.length > 0"
                >
                  <div
                    class="bag-input"
                    v-for="(bag, index) in priceResponse.baggageOptions
                      .allBaggage"
                    :key="'adultbag-' + index"
                  >
                    <b-checkbox
                      :true-value="true"
                      :false-value="false"
                      v-model="
                        passenger.baggageSelection.find(e => e.id == bag.id)
                          .selected
                      "
                    >
                      <b>
                        Add {{ bag.direction.toLowerCase() }} baggage:
                        {{ bag.description }}
                      </b>
                    </b-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="container-div"
              v-for="(passenger, index) in infants"
              :key="'infant-' + index"
            >
              <div class="passenger-block">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Infant)
                </h3>
                <h3 class="passenger-type" v-else>
                  Infant passenger {{ index + 1 }}
                </h3>
                <!-- v-if="infantSettings.showTitle" -->
                <b-field
                  label="Title"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.title }"
                  :message="{ 'Title required': passenger.errors.title }"
                >
                  <b-select v-model="passenger.title" expanded required>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Ms">Ms</option>
                  </b-select>
                </b-field>
                <b-field
                  label="First Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.firstName }"
                  :message="{
                    'First name required': passenger.errors.firstName
                  }"
                >
                  <b-input
                    @input="val => handleNameInput(val, passenger)"
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    required
                  ></b-input>
                </b-field>
                <!-- <b-field
                  v-if="infantSettings.middleNameRequired"
                  label="Middle Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.middleName }"
                  :message="{
                    'Middle name required': passenger.errors.middleName
                  }"
                >
                  <b-input
                    @input="passenger.errors.middleName = false"
                    v-model="passenger.middleName"
                    required
                  ></b-input>
                </b-field> -->
                <b-field
                  label="Last Name"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.lastName }"
                  :message="{ 'Last name required': passenger.errors.lastName }"
                >
                  <b-input
                    @input="passenger.errors.lastName = false"
                    v-model="passenger.lastName"
                    required
                  ></b-input>
                </b-field>
                <b-field
                  label="Date of Birth"
                  :label-position="labelPosition"
                  :type="{ 'is-danger': passenger.errors.dateOfBirth }"
                  :message="{
                    'Date of birth required': passenger.errors.dateOfBirth
                  }"
                >
                  <b-datepicker
                    placeholder="Click to select..."
                    v-model="passenger.dateOfBirth"
                    position="is-top-right"
                    :min-date="infantMin"
                    :max-date="travelDate"
                    required
                    @input="passenger.errors.dateOfBirth = false"
                    :years-range="[-2, 2]"
                  ></b-datepicker>
                </b-field>
                <!-- v-if="infantSettings.showNationality" -->
                <b-field
                  v-if="isInternational"
                  label="Nationality"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.nationality }"
                  :message="{
                    'Nationality required': passenger.errors.nationality
                  }"
                >
                  <b-select v-model="passenger.nationality" expanded required>
                    <option
                      v-for="country in countries"
                      :key="country.code"
                      :value="country.code"
                      >{{ country.name }}</option
                    >
                  </b-select>
                </b-field>
                <!-- v-if="infantSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport number"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.passportNumber }"
                  :message="{
                    'Passport number required': passenger.errors.passportNumber
                  }"
                >
                  <b-input
                    @input="passenger.errors.passportNumber = false"
                    v-model="passenger.passportNumber"
                    required
                  ></b-input>
                </b-field>
                <!-- v-if="infantSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport country"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.passportCountry }"
                  :message="{
                    'Passport country required':
                      passenger.errors.passportCountry
                  }"
                >
                  <b-select
                    v-model="passenger.passportCountry"
                    expanded
                    required
                  >
                    <option
                      v-for="country in countries"
                      :key="country.code"
                      :value="country.code"
                      >{{ country.name }}</option
                    >
                  </b-select>
                </b-field>
                <!-- v-if="infantSettings.requirePassport" -->
                <b-field
                  v-if="isInternational"
                  label="Passport expiry"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.tempPassportExpiry }"
                  :message="{
                    'Passport expiry required':
                      passenger.errors.tempPassportExpiry
                  }"
                >
                  <b-datepicker
                    placeholder="Click to select..."
                    position="is-top-right"
                    v-model="passenger.tempPassportExpiry"
                    :min-date="new Date()"
                    :max-date="null"
                    @input="passenger.errors.tempPassportExpiry = false"
                    :years-range="[0, 10]"
                    required
                  ></b-datepicker>
                </b-field>
                <!-- <b-field
                  v-if="
                    infantSettings.showIdNumber ||
                      infantSettings.requireAPIS ||
                      infantSettings.requireSFPD
                  "
                  :label="'I.D. number'"
                  :label-position="labelPosition"
                  expanded
                  :type="{ 'is-danger': passenger.errors.documentNumber }"
                  :message="{
                    'Document number required': passenger.errors.documentNumber
                  }"
                >
                  <b-input
                    @input="passenger.errors.documentNumber = false"
                    v-model="passenger.documentNumber"
                    required
                  ></b-input>
                </b-field> -->
                <!-- REMOVED INFANT BAGS UNTIL FIXED -->
                <!-- <div
                  class="baggage-section"
                  v-if="priceResponse.baggageOptions.allBaggage.length > 0"
                >
                  <div
                    class="bag-input"
                    v-for="(bag, index) in priceResponse.baggageOptions
                      .allBaggage"
                    :key="'adultbag-' + index"
                  >
                    <b-checkbox
                      :true-value="true"
                      :false-value="false"
                      v-model="
                        passenger.baggageSelection.find(e => e.id == bag.id)
                          .selected
                      "
                    >
                      <b>
                        Add {{ bag.direction.toLowerCase() }} baggage:
                        {{ bag.description }}
                      </b>
                    </b-checkbox>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="buttons">
            <b-button
              type="is-warning"
              @click="backPage()"
              icon-left="arrow-left"
              >Back</b-button
            >
            <b-button
              type="is-success"
              @click="validateBlock1()"
              icon-right="arrow-right"
              >Next</b-button
            >
          </div>
        </form>
      </transition>

      <transition name="rotate-in">
        <form class="block-2" v-if="block == 2">
          <div class="passenger-block">
            <b-field
              class="no-wrap"
              label="Payer is same as passenger 1?"
              horizontal
            >
              <b-checkbox
                id="samePayer"
                class="remove-margin dark-border"
                v-model="payerSameAsPassenger"
                type="checkbox"
                name="samePayer"
              ></b-checkbox>
            </b-field>
            <b-field grouped group-multiline class="multiline-fix">
              <b-field
                label="Title"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': payer.errors.title }"
                :message="{ 'Title required': payer.errors.title }"
              >
                <b-select v-model="payer.title" expanded required>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                </b-select>
              </b-field>
              <b-field
                label="First Name"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': payer.errors.firstName }"
                :message="{ 'First name required': payer.errors.firstName }"
              >
                <b-input
                  @input="payer.errors.firstName = false"
                  v-model="payer.firstName"
                  expanded
                  required
                ></b-input>
              </b-field>
              <b-field
                label="Last Name"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': payer.errors.lastName }"
                :message="{ 'Last name required': payer.errors.lastName }"
              >
                <b-input
                  @input="payer.errors.lastName = false"
                  v-model="payer.lastName"
                  expanded
                  required
                ></b-input>
              </b-field>
            </b-field>
            <b-field grouped group-multiline class="multiline-fix">
              <b-field
                label="Email"
                :label-position="labelPosition"
                expanded
                :type="{
                  'is-danger': payer.errors.email || payer.errors.isValidEmail
                }"
                :message="{
                  'Valid email required': payer.errors.email,
                  'Valid email required': payer.errors.isValidEmail
                }"
              >
                <b-input
                  @input="
                    payer.errors.email, (payer.errors.isValidEmail = false)
                  "
                  v-model="payer.email"
                  expanded
                  required
                ></b-input>
              </b-field>
              <b-field
                label="Mobile Number"
                :label-position="labelPosition"
                expanded
                :type="{
                  'is-danger':
                    payer.errors.mobileNumber ||
                    payer.errors.isValidMobileNumber
                }"
                :message="{
                  'Valid mobile number required': payer.errors.mobileNumber,
                  'Valid mobile number required':
                    payer.errors.isValidMobileNumber
                }"
              >
                <vue-tel-input
                  v-model="payer.mobileNumber"
                  expanded
                  required
                  @input="
                    payer.errors.isValidMobileNumber,
                      (payer.errors.mobileNumber = false)
                  "
                  v-on:country-changed="countryChanged"
                  :preferredCountries="['ZA']"
                ></vue-tel-input>
              </b-field>
            </b-field>
          </div>
          <div class="buttons">
            <b-button type="is-warning" @click="back()" icon-left="arrow-left"
              >Back</b-button
            >

            <b-button
              type="is-success"
              @click="validateBlock2()"
              icon-right="arrow-right"
              >Next</b-button
            >
          </div>
        </form>
      </transition>

      <transition name="rotate-in">
        <form class="block-3" v-if="block == 3">
          <div
            style="margin-bottom: 0.75em"
            v-if="paymentMethodValidationErrors"
          >
            <b-message type="is-danger"
              >One or more passenger details were determined to be invalid,
              please go back to ensure your details are correct.</b-message
            >
          </div>
          <div v-else class="passenger-block">
            <div
              v-for="(option, index) in this.paymentOptions"
              :key="'option-' + index"
            >
              <!-- 3D CREDIT CARD PAYMENT -->
              <!-- 
                <b-field
                  expanded
                  class="padding-bottom"
                  v-if="option.paymentOptionName == 'CC_3D'"
                >
                  <b-radio
                    expanded
                    class="width-100"
                    v-model="paymentOption"
                    name="paymentOption"
                    :native-value="option"
                  >
                    <span class="payment-item">
                      Pay securely with your credit card.
                      <img
                        src="@/assets/images/paymentOptions/card-logos.png"
                        alt="Credit Card Logos"
                      />
                    </span>
                  </b-radio>
                </b-field>
                DEBIT CARD PAYMENT
                <b-field
                  expanded
                  class="padding-bottom"
                  v-if="option.paymentOptionName == 'DC_3D'"
                >
                  <b-radio
                    expanded
                    class="width-100"
                    v-model="paymentOption"
                    name="paymentOption"
                    :native-value="option"
                  >
                    <span class="payment-item">
                      Pay securely with your debit card.
                      <img
                        src="@/assets/images/paymentOptions/card-logos.png"
                        alt="Credit Card Logos"
                      />
                    </span>
                  </b-radio>
                </b-field>
               -->
              <!-- CLASSIC CREDIT CARD PAYMENT -->
              <b-field
                expanded
                class="padding-bottom"
                v-if="option.paymentOptionName == 'CC'"
              >
                <b-radio
                  expanded
                  class="width-100"
                  v-model="paymentOption"
                  name="paymentOption"
                  :native-value="option"
                >
                  <span class="payment-item">
                    Pay instantly and securely with your credit card.
                    <img
                      src="@/assets/images/paymentOptions/card-logos.png"
                      alt="Credit Card Logos"
                    />
                  </span>
                </b-radio>
              </b-field>
              <!-- DEBIT CARD PAYMENT -->
              <b-field
                expanded
                class="padding-bottom"
                v-if="option.paymentOptionName == 'DC'"
              >
                <b-radio
                  expanded
                  class="width-100"
                  v-model="paymentOption"
                  name="paymentOption"
                  :native-value="option"
                >
                  <span class="payment-item">
                    Pay instantly and securely with your debit card.
                    <img
                      src="@/assets/images/paymentOptions/card-logos.png"
                      alt="Credit Card Logos"
                    />
                  </span>
                </b-radio>
              </b-field>
              <!-- CASH PAYMENT - PAY IN STORE -->
              <b-field
                expanded
                class="padding-bottom"
                v-if="
                  option.paymentOptionName == 'CASH' && departureIsValidForPnp
                "
              >
                <b-radio
                  expanded
                  class="width-100"
                  v-model="paymentOption"
                  name="paymentOption"
                  :native-value="option"
                >
                  <span class="payment-item">
                    Pay in store at Pick n Pay.
                    <img
                      src="@/assets/images/paymentOptions/pnp.png"
                      alt="Pick n Pay Logo"
                    />
                  </span>
                </b-radio>
              </b-field>
              <!-- EFT PAYMENT -->
              <b-field
                expanded
                class="padding-bottom"
                v-if="option.paymentOptionName == 'EFT'"
              >
                <b-radio
                  expanded
                  class="width-100"
                  v-model="paymentOption"
                  name="paymentOption"
                  :native-value="option"
                >
                  <span class="payment-item">
                    Pay via EFT.
                    <img
                      src="@/assets/images/paymentOptions/eft-secure.png"
                      alt="EFT secure"
                    />
                  </span>
                </b-radio>
              </b-field>
            </div>
            <div v-if="paymentOptionCost" class="payment-option-charge">
              + R{{ paymentOptionCost }} payment method fee
            </div>
          </div>
          <div class="buttons">
            <b-button type="is-warning" @click="back()" icon-left="arrow-left"
              >Back</b-button
            >

            <b-button
              type="is-success"
              @click="validateBlock3()"
              icon-right="arrow-right"
              >Next</b-button
            >
          </div>
        </form>
      </transition>

      <transition name="rotate-in">
        <form class="block-3" v-if="block == 4">
          <div class="passenger-block no-borders">
            <credit-card-form
              v-if="
                this.paymentOption.paymentOptionName === 'CC' ||
                  this.paymentOption.paymentOptionName === 'DC'
                // ||
                // this.paymentOption.paymentOptionName === 'CC_3D' ||
                // this.paymentOption.paymentOptionName === 'DC_3D'
              "
              ref="ccform"
            ></credit-card-form>
            <div v-else>
              <b-message type="is-warning"
                >Select a bank from the list below and our corresponding EFT
                details will be attached to your confirmation email.</b-message
              >
              <b-field
                v-for="(method, index) in this.paymentOption.paymentMethods"
                :key="'method-' + index"
              >
                <b-radio
                  v-model="paymentMethod"
                  name="paymentOption"
                  :native-value="method"
                >
                  <img
                    :src="
                      require('@/assets/images/paymentOptions/' +
                        method.bankId +
                        '.png')
                    "
                    :alt="method.bankId + 'logo'"
                  />
                </b-radio>
              </b-field>
            </div>
            <div v-if="paymentOptionCost" class="payment-option-charge">
              + R{{ paymentOptionCost }} payment method fee
            </div>
          </div>
          <div class="buttons">
            <b-button type="is-warning" @click="back()" icon-left="arrow-left"
              >Back</b-button
            >

            <b-button
              type="is-success"
              @click="validateBlock4()"
              icon-right="arrow-right"
              >Next</b-button
            >
          </div>
        </form>
      </transition>

      <transition name="rotate-in">
        <form class="block-3" v-if="block == 5">
          <div class="passenger-block">
            <div v-if="paymentMethod.requiresBillingAddress">
              <b-field
                label="Address line 1"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': billingDetails.errors.addressLine1 }"
                :message="{
                  'Address required': billingDetails.errors.addressLine1
                }"
              >
                <b-input
                  v-model="billingDetails.addressLine1"
                  expanded
                  required
                ></b-input>
              </b-field>
              <b-field
                label="Address line 2"
                :label-position="labelPosition"
                expanded
              >
                <b-input
                  v-model="billingDetails.addressLine2"
                  expanded
                  required
                ></b-input>
              </b-field>
              <b-field
                label="Postal code"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': billingDetails.errors.postalCode }"
                :message="{
                  'Postal code required': billingDetails.errors.postalCode
                }"
              >
                <b-input
                  v-model="billingDetails.postalCode"
                  expanded
                  required
                ></b-input>
              </b-field>
              <b-field
                label="City"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': billingDetails.errors.city }"
                :message="{ 'City required': billingDetails.errors.city }"
              >
                <b-input
                  v-model="billingDetails.city"
                  expanded
                  required
                ></b-input>
              </b-field>
              <b-field
                label="Country"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': billingDetails.errors.country }"
                :message="{ 'Country required': billingDetails.errors.country }"
              >
                <b-select v-model="billingDetails.country" expanded required>
                  <option
                    v-for="country in countries"
                    :key="country.code"
                    :value="country.code"
                    >{{ country.name }}</option
                  >
                </b-select>
              </b-field>
              <b-field
                label="Contact number"
                :label-position="labelPosition"
                expanded
                :type="{ 'is-danger': billingDetails.errors.contactNo }"
                :message="{
                  'Contact number required': billingDetails.errors.contactNo
                }"
              >
                <vue-tel-input
                  v-model="billingDetails.contactNo"
                  expanded
                  required
                  v-on:country-changed="billingCountryChanged"
                  :preferredCountries="['ZA']"
                ></vue-tel-input>
              </b-field>
            </div>
            <b-field
              v-if="this.paymentOption.paymentOptionName === 'CASH'"
              :label-position="labelPosition"
              label="Pick n Pay Smart Shopper Number"
              :type="{
                'is-danger': billingDetails.errors.pnpSmartShopperNumber
              }"
              :message="{
                'Please provide a valid smart shopper number or leave empty':
                  billingDetails.errors.pnpSmartShopperNumber
              }"
            >
              <b-input
                v-model="pnpSmartShopperNumber"
                placeholder="This field is optional"
              ></b-input>
            </b-field>
            <b-field expanded>
              <b-checkbox v-model="billingDetails.vatInvoice"
                >I require a VAT invoice</b-checkbox
              >
            </b-field>
            <b-field
              v-if="billingDetails.vatInvoice"
              label="Company name"
              :label-position="labelPosition"
              expanded
              :type="{ 'is-danger': billingDetails.errors.companyName }"
              :message="{
                'Company name required': billingDetails.errors.companyName
              }"
            >
              <b-input
                v-model="billingDetails.companyName"
                expanded
                required
              ></b-input>
            </b-field>
            <b-field
              v-if="billingDetails.vatInvoice"
              label="Company VAT No"
              :label-position="labelPosition"
              expanded
              :type="{ 'is-danger': billingDetails.errors.companyVatNo }"
              :message="{
                'Company VAT number required':
                  billingDetails.errors.companyVatNo
              }"
            >
              <b-input
                v-model="billingDetails.companyVatNo"
                expanded
                required
              ></b-input>
            </b-field>
            <transition name="slide-in-top">
              <b-field
                :type="{ 'is-danger': termsError }"
                :message="{ 'Terms and Conditions are required!': termsError }"
              >
                <b-checkbox v-model="termsAgreed">
                  I Agree to the
                  <a
                    href="https://travel.flightsite.co.za/terms-and-conditions/"
                    target="_blank"
                    >&nbsp; terms and conditions.</a
                  >
                </b-checkbox>
              </b-field>
            </transition>
          </div>
          <div class="buttons">
            <b-button type="is-warning" @click="back()" icon-left="arrow-left"
              >Back</b-button
            >

            <b-button
              type="is-success"
              @click="validateBlock5()"
              :disabled="!termsAgreed"
              icon-right="arrow-right"
              >Book now</b-button
            >
          </div>
        </form>
      </transition>
    </div>
  </div>
</template>

<script>
import Api from "../services/Api.service.js";
import { mapState } from "vuex";
import moment from "moment";
import { VueTelInput } from "vue-tel-input";
import CreditCardForm from "@/components/CreditCardForm.vue";
import TripReview from "@/components/TripReview.vue";
import Loader from "@/components/Loader.vue";
import { cloneDeep } from "lodash";
import countryCodes from "../services/CountryCodes.service";

export default {
  name: "details-list",
  data: function() {
    const today = new Date();
    return {
      block: 1,
      // redirectUrl: undefined,
      // threeDSecureParamMap: [],
      // redirect: undefined,
      pnpSmartShopperNumber: undefined,
      mobileReviewModal: false,
      payerSameAsPassenger: false,
      errors: [],
      focusedDate: new Date("2000-01-01"),
      adults: [],
      children: [],
      infants: [],
      paymentOption: "",
      paymentMethod: undefined,
      termsAgreed: false,
      termsError: false,
      payer: {
        title: "Mr",
        email: null,
        firstName: null,
        lastName: null,
        mobileNumber: null,
        mobileCode: "27",
        errors: []
      },
      billingDetails: {
        addressLine1: undefined,
        addressLine2: undefined,
        postalCode: undefined,
        city: undefined,
        country: undefined,
        contactCode: undefined,
        contactNo: undefined,
        vatInvoice: false,
        companyName: undefined,
        webpackHotUpdate: process.env.NODE_ENV === "development" ? true : false,
        companyVatNo: undefined,
        companyVatName: undefined,
        errors: []
      },
      labelPosition: "on-border",
      loaderOpen: false,
      paymentMethodResults: undefined,
      paymentMethodComplete: false,
      validationError: false
    };
  },
  computed: {
    travelDate() {
      return new Date(this.$store.state.searchParameters.itineraries[0].departDate);
    },

    childMin() {
      let travelDate = new Date(this.$store.state.searchParameters.itineraries[0].departDate);

      travelDate.setFullYear(travelDate.getFullYear() - 12);
      return travelDate;
    },

    infantMin() {
      let travelDate = new Date(this.$store.state.searchParameters.itineraries[0].departDate);

      travelDate.setFullYear(travelDate.getFullYear() - 2);
      return travelDate;
    },
    countries() {
      return countryCodes;
    },

    ...mapState([
      "selectedFlights",
      "flags",
      "priceResponse",
      "searchParameters",
      "products",
      "paymentMethodResponse",
      "paymentOptions",
      "cardDetails",
      "bookingResponse",
      "baggageCost",
      "allFlights",
      "isInternational"
    ]),
    allPassengers() {
      return [...this.adults, ...this.children, ...this.infants];
    },
    bookingHasIdenticalNames() {
      const passengers = [...this.adults, ...this.children, ...this.infants];
      // Filter out passengers with undefined or empty first and/or last names
      const validPassengers = passengers.filter(
        x => x.firstName && (x.middleName || x.middleName === "") && x.lastName
      );
      if (validPassengers.length <= 1) return false;

      const fullNames = validPassengers.map(x => {
        // Combine names with proper spacing, including middle name if it exists
        return [x.firstName, x.middleName, x.lastName]
          .filter(Boolean) // Remove undefined/null/empty values
          .join(" ");
      });

      const uniqueNames = new Set(fullNames);
      // If the list of unique names is shorter than the total list of valid passenger names,
      // then a duplicate name is present among the valid entries
      return fullNames.length !== uniqueNames.size;
    },
    blockHeading: function() {
      switch (this.block) {
        case 1:
          return "Who is travelling?";
        case 2:
          return "Who is paying?";
        case 3:
          return "Payment options";
        case 4:
          return "Payment details";
        case 5:
          return "Billing details";
        default:
          return "Details";
      }
    },
    paymentOptionCost() {
      if (this.block < 3) {
        return undefined;
      } else if (
        this.paymentMethod &&
        this.paymentMethod.products &&
        this.paymentMethod.products.length > 1
      ) {
        this.$store.commit(
          "updatePaymentCharge",
          this.paymentMethod.products[0].amount
        );
        return this.paymentMethod.products[0].amount;
      }
      return undefined;
    },
    adultSettings() {
      return this.priceResponse.passengerSettings.adultSettings;
    },
    childSettings() {
      return this.priceResponse.passengerSettings.childSettings;
    },
    infantSettings() {
      return this.priceResponse.passengerSettings.infantSettings;
    },
    paymentMethodValidationErrors() {
      if (
        !this.isEmpty(
          this.paymentMethodResponse &&
            this.paymentMethodResponse.validationResults
        )
      ) {
        if (!this.paymentMethodResponse.validationResults.isValid) {
          return true;
        }
      }
      return false;
    },
    paymentValidationErrors() {
      let result = [];
      if (!this.isEmpty(this.bookingResponse)) {
        result = Object.keys(
          this.bookingResponse.validationResults.paymentDetailsValidationResults
            .invalidFields
        );
      }
      return result;
    },
    stepBlock: {
      get() {
        return this.block - 1;
      },
      set(newVal) {
        this.setBlock(newVal + 1);
        return newVal;
      }
    },
    totalPurchasedBaggage() {
      let result = 0;
      this.adults
        .concat(this.children)
        .concat(this.infants)
        .forEach(e => {
          if (e.baggageSelection) {
            e.baggageSelection.forEach(bag => {
              if (bag.selected === true) {
                result++;
              }
            });
          }
        });
      return result;
    },
    departureIsValidForPnp() {
      try {
        if (
          this.selectedFlights.outbound &&
          this.selectedFlights.outbound.odoList.length > 0
        ) {
          const departureDate = moment(
            this.selectedFlights.outbound.odoList[0].segments[0]
              .departureDateTime
          );
          const currentTime = moment();

          const differenceInHours = Math.abs(
            currentTime.diff(departureDate, "hours")
          );

          if (differenceInHours >= 72) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  },
  watch: {
    paymentOption: {
      handler(newVal) {
        if (
          newVal.paymentOptionName == "IPAY" ||
          newVal.paymentOptionName == "CASH"
        ) {
          this.paymentMethod = newVal.paymentMethods[0];
        }
      }
    },
    payerSameAsPassenger: {
      handler(newVal) {
        return this.setPayerToPassenger(newVal);
      },
      deep: true
    },
    totalPurchasedBaggage: {
      handler() {
        let cost = 0;
        this.adults
          .concat(this.children)
          .concat(this.infants)
          .forEach(passenger => {
            if (passenger.baggageSelection) {
              passenger.baggageSelection.forEach(bag => {
                if (bag.selected) {
                  let price = this.priceResponse.baggageOptions.allBaggage.find(
                    option => {
                      return option.id == bag.id;
                    }
                  ).amount;
                  cost += price;
                }
              });
            }
          });
        this.$store.commit("updateBaggageCost", cost);
      }
    }
  },
  methods: {
    handleNameInput(value, passenger) {
      passenger.errors.firstName = false;
      const nameParts = value.trim().split(/\s+/);
      passenger.firstName = nameParts[0] || "";
      passenger.middleName = nameParts.slice(1).join(" ") || undefined;
    },
    openLoader() {
      this.$store.commit("setLoader", true);
      this.$buefy.modal.open({
        parent: this,
        component: Loader,
        canCancel: [false, false, false]
      });
    },
    closeLoader() {
      this.$store.commit("setLoader", false);
    },
    toggleMobileReview() {
      this.mobileReviewModal = !this.mobileReviewModal;
    },
    clearError(val) {
      console.log(val);
      val = undefined;
    },
    setBlock(val) {
      this.block = val;
      this.$store.commit("updateBlock", val);
    },
    async autofill() {
      this.adults
        .concat(this.children)
        .concat(this.infants)
        .forEach(e => {
          e.firstName = "test";
          e.lastName = "test";
          e.dateOfBirth = new Date("1990-05-02");
        });
      this.payerSameAsPassenger();
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    countryChanged(country) {
      this.payer.mobileCode = country.dialCode;
    },
    billingCountryChanged(country) {
      this.billingDetails.contactCode = country.dialCode;
    },
    initBooking() {
      this.openLoader();
      this.validationError = false;
      this.$store.commit("setPayer", this.payer);
      this.$store.commit("setPassengers", {
        adults: this.adults,
        children: this.children,
        infants: this.infants
      });
      this.book();
    },
    async book() {
      let body = {
        data: this.priceResponse.data,
        sessionID: this.$store.state.session,
        paymentData: this.paymentMethodResponse.data,
        paymentReturnURL:
          this.paymentOption.paymentOptionName === "CC_3D" ||
          this.paymentOption.paymentOptionName === "DC_3D"
            ? process.env.VUE_APP_BASE_API_URL + "/three-d-redirect"
            : null,
        contact: {
          email: this.payer.email,
          firstName: this.payer.firstName,
          lastName: this.payer.lastName,
          mobileCode: this.payer.mobileCode,
          mobileNo: this.payer.mobileNumber.replace(/\s+/g, ""),
          title: this.payer.title
        },
        ignoreDuplicateBookings: true,
        passengers: {
          adults: this.cleanPassengers(this.adults),
          children: this.cleanPassengers(this.children),
          infants: this.cleanPassengers(this.infants)
        },
        products: this.products,
        selectedPaymentMethod: this.paymentMethod,
        cardDetails: this.cardDetails
          ? this.cleanCardDetails(this.cardDetails)
          : undefined,
        billingDetails: this.paymentMethod.requiresBillingAddress
          ? this.cleanAddress(this.billingDetails)
          : undefined,
        deliveryDetails: this.paymentMethod.requiresBillingAddress
          ? this.cleanAddress(this.billingDetails)
          : undefined,
        baggageSelection: this.baggageSelection
          ? this.baggageSelection
          : undefined,
        voucherProduct: this.voucherProduct ? this.voucherProduct : undefined,
        pnpSmartShopperNumber: this.pnpSmartShopperNumber
          ? this.pnpSmartShopperNumber
          : undefined
      };
      this.$store.commit("saveBookBody", body);
      const result = await Api.book(body);

      if (result.status != 200) {
        this.closeLoader();
        this.$router.push("failure");

        return;
      }

      this.$store.commit("setBookingResponse", result.data);
      if (result.data.errors) {
        console.log("book failed with errors");
        this.billingDetails.errors = [];
        this.payer.errors = [];
        this.closeLoader();
        this.$router.push("failure");
      } else if (
        result.data.validationResults &&
        !result.data.validationResults.isValid
      ) {
        this.billingDetails.errors = [];
        this.payer.errors = [];
        console.log("book failed with vailidation error");
        this.validationError = true;
        this.closeLoader();
      } else if (result.data.threeDSecureBookingResponse) {
        this.closeLoader();
        this.$router.push("threeDSecure");
      } else if (result.data.redirectGatewayBookingResponse) {
        this.closeLoader();
        this.$router.push("ipay");
      } else {
        this.closeLoader();
        this.$router.push("confirmation");
      }
    },
    generatePnpTickets() {
      let tickets = [];
      let schedules = [];
      this.allFlights.forEach(flight => {
        schedules.push({
          description: `Flight from ${flight.origCode} to ${flight.destCode}`,
          referenceNumber: "123",
          startDateTime: moment(flight.departureDateTime).format(
            "DD/MM/YYYY HH:mm"
          )
        });
      });
      this.adults
        .concat(this.children)
        .concat(this.infants)
        .forEach(passenger => {
          tickets.push({
            person: {
              firstName: passenger.firstName,
              middleName: passenger.middleName,
              lastName: passenger.lastName,
              contactNumber: this.payer.mobileNumber.replace(/\s+/g, "")
            },
            schedules: schedules
          });
        });
      return tickets;
    },
    async paymentMethods() {
      this.openLoader();
      try {
        const result = await Api.paymentMethods({
          data: this.priceResponse.data,
          sessionID: this.$store.state.session,
          contact: {
            email: this.payer.email,
            firstName: this.payer.firstName,
            lastName: this.payer.lastName,
            mobileCode: this.payer.mobileCode,
            mobileNo: this.payer.mobileNumber.replace(/\s+/g, ""),
            title: this.payer.title
          },
          ignoreDuplicateBookings: true,
          passengers: {
            adults: this.cleanPassengers(this.adults),
            children: this.cleanPassengers(this.children),
            infants: this.cleanPassengers(this.infants)
          },
          products: this.products,
          baggageSelection: this.baggageSelection
            ? this.baggageSelection
            : undefined,
          voucherProduct: this.voucherProduct ? this.voucherProduct : undefined
        });
        this.paymentMethodsResults = result.data;
        this.$store.commit("setPaymentMethodResponse", result.data);
        this.paymentMethodsComplete = true;
        if (!result.data.errors) {
          this.block++;
          this.$store.commit("updateBlock", this.block);
          this.closeLoader();
        } else {
          this.closeLoader();
          this.$router.push("failure");
        }
      } catch (error) {
        this.closeLoader();
        this.$router.push("failure");
      }
    },
    cleanPassengers(passengers) {
      passengers.forEach(passenger => {
        passenger.errors = undefined;
      });
      return passengers;
    },
    cleanAddress(address) {
      address.errors = undefined;
      return address;
    },
    cleanCardDetails(card) {
      card.cardType = undefined;
      return card;
    },
    validateMaxCharLengthOnPassenger(passenger) {
      const validationCharacterLimit = this.isVerteil ? 39 : 59;
      const dobLength = 8; // Standard length for dates of birth
      const maxCharacterLength = validationCharacterLimit - dobLength;

      // Include middle name in the full name calculation with proper spacing
      const fullName = [
        passenger.title,
        passenger.firstName,
        passenger.middleName,
        passenger.lastName
      ]
        .filter(Boolean)
        .join(""); //combines with no spaces

      return fullName.length <= maxCharacterLength;
    },
    validateMaxLengthForInfantBookings(infant, adult) {
      const adultCharacters = [
        adult.title,
        adult.firstName,
        adult.middleName,
        adult.lastName
      ]
        .filter(Boolean)
        .join("");

      const haveSameSurnames = infant.lastName === adult.lastName;

      const infantCharacters = [
        infant.title,
        infant.firstName,
        infant.middleName,
        // Only add lastName if it's different from adult's
        haveSameSurnames ? "" : infant.lastName
      ]
        .filter(Boolean)
        .join(""); //combines with no spaces

      const validationCharacterLimit = this.isVerteil ? 39 : 59;
      const dobLength = 8 * 2; // Standard length for two dates of birth
      const maxCharacterLength = validationCharacterLimit - dobLength;

      return (
        `${infantCharacters}${adultCharacters}`.length <= maxCharacterLength
      );
    },
    formatPassengerDates(passenger) {
      let momentDate = moment(passenger.dateOfBirth);
      passenger.dob.day = Number(momentDate.format("DD"));
      passenger.dob.month = Number(momentDate.format("MM"));
      passenger.dob.year = Number(momentDate.format("YYYY"));
      if (passenger.tempPassportExpiry) {
        let momentDate = moment(passenger.tempPassportExpiry);
        passenger.passportExpiry = {
          day: Number(momentDate.format("DD")),
          month: Number(momentDate.format("MM")),
          year: Number(momentDate.format("YYYY"))
        };
      }
    },
    setPayerToPassenger: function(isTrue) {
      if (isTrue) {
        this.payer.title = this.adults[0].title;
        // Combine firstName and middleName with a space if middleName exists
        this.payer.firstName = [
          this.adults[0].firstName,
          this.adults[0].middleName
        ]
          .filter(Boolean)
          .join(" ");
        this.payer.lastName = this.adults[0].lastName;
      } else {
        this.payer.title = null;
        this.payer.firstName = null;
        this.payer.lastName = null;
      }
    },
    validateMiddleName: function(name) {
      if (!name) {
        return true; // Middle name is optional, so it's valid if not provided
      }

      if (/\d/.test(name)) {
        console.log("num");
        return false;
      }

      if (/[^a-zA-Z\s-]/.test(name)) {
        //allow hyphens and spaces
        console.log("special characters");
        return false;
      }

      return true;
    },
    validateName: function(name) {
      if (!name) {
        console.log("null");
        return false;
      }

      if (/\d/.test(name)) {
        console.log("num");
        return false;
      }

      if (name.length <= 1) {
        console.log("length");
        return false;
      }

      if (/[^a-zA-Z\s-]/.test(name)) {
        //allow hyphens and spaces
        console.log("special characters");
        return false;
      }

      return true;
    },
    validateBlock1: function() {
      this.errors = [];
      let valid = true;
      if (this.bookingHasIdenticalNames) valid = false;

      // Max character limit check for adults and infants bookings
      // Iterate through all passengers, including adults, children, and infants
      for (let i = 0; i < this.adults.length; i++) {
        const adult = this.adults[i];
        const infant = this.infants[i];

        // If there's an infant at the same index as the adult, validate them
        if (infant) {
          if (!this.validateMaxLengthForInfantBookings(infant, adult)) {
            this.errors.push(
              `Validation failed for infant at index ${i} with corresponding adult.`
            );
            this.maxBookingCharacterLengthError = true;
            return (valid = false);
          }
        }
      }

      for (let passenger of this.adults
        .concat(this.children)
        .concat(this.infants)) {
        passenger.errors = [];

        // Validate max character length on each passenger
        if (!this.validateMaxCharLengthOnPassenger(passenger)) {
          this.errors.push(`Passenger character limit exceeded.`);
          passenger.errors.fullNameTooLong = true;
          return (valid = false);
        }

        if (!this.isInternational) {
          const today = new Date();
          passenger.nationality = "ZA";
          passenger.passportNumber = "11111111";
          passenger.passportCountry = "ZA";
          passenger.tempPassportExpiry = new Date(today.getFullYear() + 1);
        }
        this.formatPassengerDates(passenger);
        if (!passenger.title) {
          passenger.errors.title = true;
          valid = false;
        }
        if (!this.validateName(passenger.firstName)) {
          passenger.errors.firstName = true;
          valid = false;
        }
        if (!this.validateMiddleName(passenger.middleName)) {
          passenger.errors.firstName = true;
          valid = false;
        }
        if (!this.validateName(passenger.lastName)) {
          passenger.errors.lastName = true;
          valid = false;
        }
        if (!passenger.dateOfBirth) {
          passenger.errors.dateOfBirth = true;
          valid = false;
        }
        if (passenger.type === "ADULT") {
          if (this.isInternational && !passenger.nationality) {
            passenger.errors.nationality = true;
            valid = false;
          }
          // this.adultSettings.requirePassport || this.adultSettings.requireAPIS && !passenger.passportNumber
          if (this.isInternational && !passenger.passportNumber) {
            passenger.errors.passportNumber = true;
            valid = false;
          }

          // this.adultSettings.requirePassport || this.adultSettings.requireAPIS  &&
          // !passenger.passportCountry

          if (this.isInternational && !passenger.passportCountry) {
            passenger.errors.passportCountry = true;
            valid = false;
          }
          if (this.isInternational && !passenger.tempPassportExpiry) {
            passenger.errors.tempPassportExpiry = true;
            valid = false;
          }
          // if (
          //   (
          //     this.adultSettings.showIdNumber || this.adultSettings.requireSFPD) &&
          //   !passenger.documentNumber
          // ) {
          //   passenger.errors.documentNumber = true;
          //   valid = false;
          // }
        } else if (passenger.type === "CHILD") {
          if (this.isInternational && !passenger.nationality) {
            passenger.errors.nationality = true;
            valid = false;
          }
          // this.childSettings.requirePassport || this.childSettings.requireAPIS && !passenger.passportNumber
          if (this.isInternational && !passenger.passportNumber) {
            passenger.errors.passportNumber = true;
            valid = false;
          }
          // this.childSettings.requirePassport || this.childSettings.requireAPIS &&
          // !passenger.passportCountry
          if (this.isInternational && !passenger.passportCountry) {
            passenger.errors.passportCountry = true;
            valid = false;
          }
          if (this.isInternational && !passenger.tempPassportExpiry) {
            passenger.errors.tempPassportExpiry = true;
            valid = false;
          }
          // if (
          //   (this.childSettings.showIdNumber) &&
          //   !passenger.documentNumber
          // ) {
          //   passenger.errors.documentNumber = true;
          //   valid = false;
          // }
        } else if (passenger.type === "INFANT") {
          if (this.isInternational && !passenger.nationality) {
            passenger.errors.nationality = true;
            valid = false;
          }
          //           this.infantSettings.requirePassport || this.infantSettings.requireAPIS &&
          // !passenger.passportNumber
          if (this.isInternational && !passenger.passportNumber) {
            passenger.errors.passportNumber = true;
            valid = false;
          }
          //           this.infantSettings.requirePassport || this.infantSettings.requireAPIS &&
          // !passenger.passportCountry
          if (this.isInternational && !passenger.passportCountry) {
            passenger.errors.passportCountry = true;
            valid = false;
          }
          if (this.isInternational && !passenger.tempPassportExpiry) {
            passenger.errors.tempPassportExpiry = true;
            valid = false;
          }
          // if (
          //   (this.infantSettings.showIdNumber) &&
          //   !passenger.documentNumber
          // ) {
          //   passenger.errors.documentNumber = true;
          //   valid = false;
          // }
        }
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        return false;
      }
      this.errors = [];
      this.block++;
      this.$store.commit("updateBlock", this.block);
    },
    validateBlock2: function() {
      this.errors = [];
      let valid = true;
      this.payer.errors = [];
      if (!this.validateName(this.payer.firstName)) {
        this.payer.errors.firstName = true;
        valid = false;
      }
      if (!this.validateName(this.payer.lastName)) {
        this.payer.errors.lastName = true;
        valid = false;
      }
      if (!this.payer.title) {
        this.payer.errors.title = true;
        valid = false;
      }
      if (!this.payer.mobileNumber) {
        this.payer.errors.mobileNumber = true;
        valid = false;
      } else if (
        !this.validMobile(this.payer.mobileNumber.replace(/\s+/g, ""))
      ) {
        this.payer.errors.isValidMobileNumber = true;
        valid = false;
      }
      if (!this.payer.email) {
        this.payer.errors.email = true;
        valid = false;
      } else if (!this.validEmail(this.payer.email)) {
        this.payer.errors.isValidEmail = true;
        valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        return false;
      }
      this.errors = [];
      this.paymentMethods();
    },
    validateBlock3: function() {
      this.errors = [];
      let valid = true;
      if (
        this.paymentOption.paymentOptionName === "CC" ||
        this.paymentOption.paymentOptionName === "DC" ||
        // this.paymentOption.paymentOptionName === "CC_3D" ||
        // this.paymentOption.paymentOptionName === "DC_3D" ||
        this.paymentOption.paymentOptionName === "EFT"
      ) {
        this.block++;
        this.$store.commit("updateBlock", this.block);
      } else if (
        this.paymentOption.paymentOptionName === "IPAY" ||
        this.paymentOption.paymentOptionName === "CASH"
      ) {
        this.block = 5;
        this.$store.commit("updateBlock", this.block);
      } else {
        this.valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        return false;
      }
    },
    validateBlock4: function() {
      // Credit Card booking flow
      if (
        this.paymentOption.paymentOptionName === "CC" ||
        this.paymentOption.paymentOptionName === "DC"
        // ||
        // this.paymentOption.paymentOptionName === "CC_3D" ||
        // this.paymentOption.paymentOptionName === "DC_3D"
      ) {
        this.$refs.ccform.commitCardDetail();
        switch (this.cardDetails.cardType) {
          case "visa":
            this.paymentMethod = this.paymentOption.paymentMethods.find(
              e => e.paymentMethodName == "VC"
            );
            break;
          case "mastercard":
            this.paymentMethod = this.paymentOption.paymentMethods.find(
              e => e.paymentMethodName == "MC"
            );
            break;
          case "amex":
            this.paymentMethod = this.paymentOption.paymentMethods.find(
              e => e.paymentMethodName == "AE"
            );
            break;
          case "dinersclub":
            this.paymentMethod = this.paymentOption.paymentMethods.find(
              e => e.paymentMethodName == "DC"
            );
            break;
          default:
            break;
        }
      } else if (this.isEmpty(this.paymentMethod)) {
        this.errors.push("Invalid or undefined payment method.");
        return false;
      }
      this.block++;
      this.$store.commit("updateBlock", this.block);
    },
    validateBlock5: function() {
      this.errors = [];
      this.termsError = false;
      let valid = true;
      if (
        this.billingDetails.errors &&
        this.paymentMethod.requiresBillingAddress
      ) {
        if (!this.billingDetails.addressLine1) {
          this.billingDetails.errors.addressLine1 = true;
          valid = false;
        }
        if (!this.billingDetails.addressLine2) {
          this.billingDetails.addressLine2 = undefined;
        }
        if (!this.billingDetails.postalCode) {
          this.billingDetails.errors.postalCode = true;
          valid = false;
        }
        if (!this.billingDetails.city) {
          this.billingDetails.errors.city = true;
          valid = false;
        }
        if (!this.billingDetails.country) {
          this.billingDetails.errors.country = true;
          valid = false;
        }
        if (!this.billingDetails.contactNo) {
          this.billingDetails.errors.contactNo = true;
          valid = false;
        } else if (
          !this.validMobile(this.billingDetails.contactNo.replace(/\s+/g, ""))
        ) {
          this.billingDetails.errors.isValidContactNo = true;
          valid = false;
        }
        if (
          this.billingDetails.vatInvoice &&
          !this.billingDetails.companyName
        ) {
          this.billingDetails.errors.companyName = true;
          valid = false;
        }
        if (
          this.billingDetails.vatInvoice &&
          !this.billingDetails.companyVatNo
        ) {
          this.billingDetails.errors.companyVatNo = true;
          valid = false;
        }
      }
      if (!this.termsAgreed) {
        this.errors.push("Must Agree to terms and conditions.");
        this.termsError = true;
        valid = false;
      }
      if (
        this.pnpSmartShopperNumber &&
        !this.isValidSmartShopperNumber(
          this.pnpSmartShopperNumber.replace(/\s+/g, "")
        )
      ) {
        this.errors.push("Invalid Smartshopper number entered.");
        this.billingDetails.errors.pnpSmartShopperNumber = true;
        valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incorrect..");
        return false;
      }
      this.errors = [];
      this.initBooking();
    },
    isValidSmartShopperNumber: function(number) {
      try {
        number = number.trim();
        if (number.length === 16 && number.startsWith("")) {
          const DELTAS = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];
          let checksum = 0;
          const chars = number.split("");
          for (let i = chars.length - 1; i > -1; i--) {
            const j = chars[i].charCodeAt(0) - 48;
            checksum += j;
            if ((i - chars.length) % 2 === 0) {
              checksum += DELTAS[j];
            }
          }
          return checksum % 10 === 0;
        } else {
          return false;
        }
      } catch {
        return false;
      }
    },
    back: async function() {
      this.errors = [];
      if (this.block == 2) {
        await this.initPassengers();
      }
      this.block--;
      this.$store.commit("updateBlock", this.block);
    },
    backPage: function() {
      this.errors = [];
      this.$store.commit("resetSelectedFlights");
      this.$router.go(-1);
    },
    validEmail: function(email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validMobile: function(mobileNumber) {
      let re = /^(\+\d{1,3}[- ]?)?((\d[- ]*)+)$/;
      return re.test(mobileNumber);
    },
    validYear: function(year) {
      let re = /^(19|20)\d{2}$/;
      return re.test(year);
    },
    validMonth: function(month) {
      let re = /^(0[1-9]|1[012])$/;
      return re.test(month);
    },
    initPassengers() {
      this.adults.length = 0;
      this.children.length = 0;
      this.infants.length = 0;
      let baggageSelection =
        this.priceResponse.baggageOptions.allBaggage.length > 0
          ? []
          : undefined;
      this.priceResponse.baggageOptions.allBaggage.forEach(bag => {
        baggageSelection.push({
          id: bag.id,
          selected: false
        });
      });
      for (let i = 0; i < this.searchParameters.travellers.adults; i++) {
        this.adults.push({
          dob: {
            day: 10,
            month: 6,
            year: 1991
          },
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          middleName: undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          passportExpiry: undefined,
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: undefined,
          title: "Mr",
          type: "ADULT",
          errors: []
        });
      }
      for (let i = 0; i < this.searchParameters.travellers.children; i++) {
        this.children.push({
          dob: {
            day: 10,
            month: 6,
            year: 1991
          },
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          middleName: undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          passportExpiry: undefined,
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: undefined,
          title: "Mr",
          type: "CHILD",
          errors: []
        });
      }
      for (let i = 0; i < this.searchParameters.travellers.infants; i++) {
        this.infants.push({
          dob: {
            day: 10,
            month: 6,
            year: 1991
          },
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          middleName: undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          passportExpiry: undefined,
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: undefined,
          title: "Mr",
          type: "INFANT",
          errors: []
        });
      }
      Promise.resolve();
    }
  },
  mounted() {
    this.initPassengers();
    this.$store.commit("updateBlock", 1);
  },
  /* eslint-disable vue/no-unused-components */
  components: {
    VueTelInput,
    CreditCardForm,
    TripReview,
    Loader
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

@media (max-width: 781px) {
  .multiline-fix {
    margin-bottom: 0.75em !important;
    * {
      margin-right: 0 !important;
      width: 100% !important;
    }
    flex-wrap: wrap;
  }
}

.steps {
  grid-area: steps;
  align-self: start;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column-reverse;
}

.passenger-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
}

.width-100 {
  width: 100%;
}

.no-borders {
  border: none;
}

.how-it-works {
  font-size: 0.8em;
  color: $primary-color;
  text-decoration: underline;
  cursor: pointer;
}

.margin-bottom-small {
  margin-bottom: 0.75em !important;
}

.block-2,
.block-3 {
  max-width: 600px;
}

.margin-bottom {
  margin-bottom: 1.5em !important;
}

.bag-input {
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  font-size: 12px;
}

.payment-option-charge {
  font-size: 12px;
  margin-top: 1em;
  color: #23d160;
  font-weight: bold;
}

.padding-bottom {
  padding-bottom: 0.75em;
}

.redeem-notice {
  font-size: 0.8em;
  color: darken($grey, 30%);
  margin-bottom: 0.75em;
}

.passenger-block {
  margin-bottom: 1.25em;
  background: $light;
  padding: 0.75em;
  width: 100%;
  border-radius: 8px;
  border-left: 4px solid $secondary-color;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
}

.no-wrap {
  white-space: nowrap;
}

.modal-close {
  padding: 0.2em;
  display: flex;
  justify-content: flex-end;
}

.mobile-review-modal {
  z-index: 11;
  margin-top: 80px;
}

.dev-only {
  padding: 0.4em;
  margin: 15px 0;
  width: fit-content !important;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid black;
  background: lightcoral;
  border-radius: 6px;
  color: white;
}

.rotate-in-enter-active {
  animation: slide-in-left-less 0.15s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.passenger-type {
  width: fit-content;
  margin-bottom: 1em;
}

#details-page {
  border-radius: 8px;
  max-width: 88%;
}

.search-overview {
  font-size: 0.8em;
}

.container-div {
  display: flex;
  width: 90%;
  margin: 0 0.5em;
}

form {
  width: 100%;
}

form,
#details-page {
  margin: 0 auto 1em auto;
  margin-bottom: 0.67em;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: -webkit-fill-available;
  .booking-button {
    padding: 0.4em;
    border: 1px solid $primary-dark;
    background: $primary-color;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    .booking-prompt {
      color: white !important;
    }
  }
}
.block-navigation-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}
.block-navigation {
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  border-radius: 8px;
  background: $light;
  div {
    width: auto;
    cursor: pointer;
    padding: 0.4em 1em;
  }
  span {
    color: darken($primary-dark, 30%);
  }
  span + i {
    margin-left: 0.5em;
  }
  i + span {
    margin-left: 0.5em;
  }
}

.payment-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block-heading {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0.75em;
}

.mobile-toolbar {
  width: 100%;
  margin-bottom: 1em;
  background: white;
  padding: 0.75em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid lightgray;
}

.main-content {
  margin: 0 0.75rem;
}

@media (min-width: 781px) {
  .trip-reivew {
    margin: 0;
    grid-area: review;
    align-self: start;
  }

  .container-div {
    width: 48%;
  }

  .container-div:nth-child(3) {
    margin-right: auto;
  }

  .main-content {
    grid-area: main;
    margin: 0;
    display: grid;
    align-self: start;
    grid-row-gap: 1rem;
    grid-template-areas:
      "steps steps steps"
      "form form form";
  }

  #details-page {
    background: none;
    border: none;
    box-shadow: none;
    margin: 2em auto;
    display: grid;
    padding-top: 0;
    min-width: 860px;
    max-width: 1080px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 0.75em;
    grid-template-areas: "main main review";
  }

  .block-navigation-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    * + * {
      margin-left: 0.75em;
    }
  }
  .multiline-fix {
    flex-wrap: nowrap !important;
  }
  .is-column {
    flex-direction: column;
  }
  form {
    min-width: 400px;
    align-self: start;
    grid-area: form;
    border-radius: 8px;
    max-width: -webkit-fill-available;
  }

  .passenger-block {
    padding: 1.5em;
  }

  .form-errors {
    align-self: flex-start;
    width: 100%;
    grid-area: review;
    background: $light;
    padding: $standard-padding;
    border-radius: 8px;
    box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
    max-width: -webkit-fill-available;
  }
  .block-heading {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-top: 0.75em;
    white-space: nowrap;
  }
}
</style>

<style lang="scss">
.control-label {
  width: 100%;
  align-items: center;
  display: flex;
  img {
    height: 30px;
  }
}

.dark-border {
  border: 2px solid #666;
}

.remove-margin {
  span {
    margin: 0 !important;
  }
}

.control .help.counter {
  display: none !important;
}

.square-list {
  list-style-type: square !important;
}

@media (max-width: 781px) {
  .label {
    font-size: 10px !important;
  }
}

@media (min-width: 781px) {
  .field-max {
    max-width: 200px !important;
  }
  .limit-select {
    max-height: 250px !important;
  }
}
</style>
